module.exports = __webpack_public_path__ + "img/banner.1799a43f.png";